import React, { useEffect } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import { PublicPageTemplate } from 'ui/templates';

import pageData from 'ui/staticSiteData/premiumAccountDescriptionData/data';

import { defaultMetaTags } from 'default-meta';
import { createPage } from 'libs/ssr/createPage';
import { MetaTags } from 'libs/metaTags';

import { usePremiumAccountDescription } from './premium-account.model';

import s from './premium-account-description.page.module.css';

function PremiumAccountPage() {
  const {
    getPremiumAccountDescription,
    premiumAccountDescription,
  } = usePremiumAccountDescription();

  useEffect(() => {
    getPremiumAccountDescription();
  }, []);

  const PlusItem = ({ card }) => (
    <div className={s.plusWrapper}>
      <img className={s.icon} src={`${card['image_url']}`} />
      <div className={s.textBlock}>
        <div className={s.title}>{card.title}</div>
        <div
          className={s.description}
          dangerouslySetInnerHTML={{ __html: card['content'] }}
        />
      </div>
    </div>
  );

  const PriceItem = ({ price, oldPrice, per, title, pluses, className }) => (
    <div className={cn(s.priceWrapper, className)}>
      <h3 className={s.title}>{title}</h3>
      <div className={s.price}>
        <span className={s.current}>{price}</span>&nbsp;
        <span className={s.per}>per {per}</span>
        {oldPrice && <span className={s.oldPrice}>{oldPrice}</span>}
      </div>
      <ul className={s.pluses}>
        {pluses.map((plus, i) => (
          <li key={i} className={s.plus}>
            {plus}
          </li>
        ))}
      </ul>
      <Link className={s.button} to="/sign-up-provider">
        Sign Up
      </Link>
    </div>
  );

  return (
    <PublicPageTemplate>
      <MetaTags {...metaTags} />

      <div className={s.pageWrapper}>
        <section className={s.headerBlock}>
          <div className={s.blockContainer}>
            <h1 className={s.title}>Pawzr Premium</h1>
          </div>
        </section>
        <section className={s.blogPlusGrid}>
          {premiumAccountDescription.map((card, i) => (
            <PlusItem key={i} card={card} />
          ))}
        </section>
        <section className={s.priceBlock}>
          <div className={s.priceBlocks}>
            <PriceItem className={s.left} {...pageData.en.monthPriceData} />
            <PriceItem className={s.right} {...pageData.en.yearPriceData} />
          </div>
        </section>
        <div className={s.joinBlock}>
          <div className={s.text}>Already have an account?</div>
          <Link to="/login" className={s.button}>
            Sign In
          </Link>
        </div>
      </div>
    </PublicPageTemplate>
  );
}

const metaTags = {
  ...defaultMetaTags,
  title: 'Pawzr Premium | Pawzr',
};

export default createPage(PremiumAccountPage, {
  //  TODO: loadata
  renderMetaTags: (url, _, host) => <MetaTags {...metaTags} url={url} />,
});
